import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const pricesWithoutDiscountAB: 'a' | 'b' | 'c' | 'd' = getFeature('prices-without-discout') || 'a';

const PWDMainTariffsYear: Array<string> = getFeature('prices-without-discount-main-tariffs-year') || [
    'W256GB_1y_landing_segmentation_main',
    'W512GB_1y_landing_segmentation_main',
    'W1TB_1y_landing_segmentation_main',
    'W2TB_1y_landing_segmentation_main',
    'W4TB_1y_landing_segmentation_main',
];
const PWDMainTariffsMonth: Array<string> = getFeature('prices-without-discount-main-tariffs-month') || [
    'W256GB_1m_landing_segmentation_main',
    'W512GB_1m_landing_segmentation_main',
    'W1TB_1m_landing_segmentation_main',
    'W2TB_1m_landing_segmentation_main',
    'W4TB_1m_landing_segmentation_main',
];
const PWDMinimalTariffsYear: Array<string> = getFeature('prices-without-discount-minimal-tariffs-year') || [
    'W256GB_1y_minimal_line_with_ads_v3',
    'W512GB_1y_minimal_line_with_ads_v3',
    'W1TB_1y_minimal_line_with_ads_v3',
    'W2TB_1y_minimal_line_with_ads_v3',
    'W4TB_1y_minimal_line_with_ads_v3',
];
const PWDMinimalTariffsMonth: Array<string> = getFeature('prices-without-discount-minimal-tariffs-month') || [
    'W256GB_1m_minimal_line_with_ads_v2',
    'W512GB_1m_minimal_line_with_ads',
    'W1TB_1m_minimal_line_with_ads',
    'W2TB_1m_minimal_line_with_ads',
    'W4TB_1m_minimal_line_with_ads_v2',
];
const PWDFamilyTariffsYear: Array<string> = getFeature('prices-without-discount-family-tariffs-year') || [
    'W256GB_1y_family_segment',
    'W512GB_1y_family_segment',
    'W1TB_1y_family_segment',
    'W2TB_1y_family_segment',
    'W4TB_1y_family_segment',
];
const PWDFamilyTariffsMonth: Array<string> = getFeature('prices-without-discount-family-tariffs-month') || [
    'W256GB_1m_family_features_mobile_a',
    'W512GB_1m_family_features_mobile_a',
    'W1TB_1m_family_features_mobile_a',
    'W2TB_1m_family_features_mobile_a',
    'W4TB_1m_family_features_mobile_a',
];
const PWDBusinessTariffsYear: Array<string> = getFeature('prices-without-discount-business-tariffs-year') || [
    'W256GB_1y_business',
    'W512GB_1y_business',
    'W1TB_1y_business',
    'W2TB_1y_business',
    'W4TB_1y_business',
];
const PWDBusinessTariffsMonth: Array<string> = getFeature('prices-without-discount-business-tariffs-month') || [
    'W256GB_1m_business_discount',
    'W512GB_1m_business_discount',
    'W1TB_1m_business_discount',
    'W2TB_1m_business_discount',
    'W4TB_1m_business_discount',
];
export const PWDMainTariffs = {
    year: PWDMainTariffsYear,
    month: PWDMainTariffsMonth,
};
export const PWDMinimalTariffs = {
    year: PWDMinimalTariffsYear,
    month: PWDMinimalTariffsMonth,
};
export const PWDFamilyTariffs = {
    year: PWDFamilyTariffsYear,
    month: PWDFamilyTariffsMonth,
};
export const PWDFamilyDesktopTariff = getFeature('prices-without-discount-family-tariff-desktop') || 'W1TB_family_segment';
export const PWDBusinessTariffs = {
    year: PWDBusinessTariffsYear,
    month: PWDBusinessTariffsMonth,
};
